function Banner() {
    return (
        <section className="main-banner" id="top" style={{height: "85vh", paddingBottom: "0px"}}>

            <video autoPlay loop muted id="bg-video" style={{width: "100%"}}>
                <source src="/video/video1.mp4" type="video/mp4"/>
            </video>

            <div className="video-overlay header-text" style={{justifyContent: "flex-end"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="caption">
                                <h2 align="center"> HOŞGELDİNİZ</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Banner;
